import { DrawerBloc } from "@/components/widget/drawer-bloc"
import { PageProps } from "@/types/page"
import { Box } from "@mui/material"
import BaseAppBar from "@/components/base/app-bar"
import useStyles from "./styles"

export const OverviewContainer = ({ onClose, open, children }: PageProps) => {
    const { classes } = useStyles()

    return (
        <DrawerBloc
            disableEscapeKeyDown
            hideBackdrop
            anchor={"right"}
            open={open}
            onClose={onClose}
            transitionDuration={600}
            classPaper={classes.container}
            data-testid="drawer-bloc"
        >
            <BaseAppBar />
            <Box className="children-wrapper">{children}</Box>
        </DrawerBloc>
    )
}
